import React from 'react';
import { motion } from 'framer-motion';
interface FeatureSectionProps {
  bgColor: string;
  textColor: string;
  headline: string;
  subtitle?: string;
  imageUrl: string;
  imageAlt: string;
  reverse?: boolean;
}
export function FeatureSection({
  bgColor,
  textColor,
  headline,
  subtitle,
  imageUrl,
  imageAlt,
  reverse = false
}: FeatureSectionProps) {
  return <section className={`${bgColor} py-20 md:py-28 px-6 overflow-hidden`} data-id="element-31" data-mp="1weurkz862do3">
      <div className={`max-w-5xl mx-auto flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-10 md:gap-20`} data-id="element-32" data-mp="21bv33pnsc8ml">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="flex-1 text-center md:text-left" data-id="element-33" data-mp="2acjesdpphwwb">
          <h2 className={`text-4xl md:text-6xl font-black ${textColor} mb-4 leading-tight`} data-id="element-34" data-mp="2ir7avyv29k0q">
            {headline}
          </h2>
          {subtitle && <p className={`text-lg md:text-xl ${textColor} opacity-70 font-medium max-w-md mx-auto md:mx-0`} data-id="element-35" data-mp="290uhdh59qgig">
              {subtitle}
            </p>}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="flex-shrink-0 flex justify-center" data-id="element-36" data-mp="31q1oh4isgefb">
          <img src={imageUrl} alt={imageAlt} className="w-full max-w-[220px] md:max-w-[260px] h-auto rounded-[2rem] shadow-xl" data-id="element-37" data-mp="1hapxdjlf7vhr" />
        </motion.div>
      </div>
    </section>;
}